































import { Component, Prop, Vue } from 'vue-property-decorator'
import { isObject } from '@/utils'
import { hls } from '@/units'

@Component
export default class Select extends Vue {
  @Prop([Number, Array]) value!: any
  @Prop(Boolean) multiple!: boolean
  @Prop(Boolean) object!: boolean
  @Prop(Boolean) search!: boolean

  @Prop(String) placeholder!: string

  @Prop({
    type: Array,
    required: true
  }) options!: any

  @Prop({
    type: Object,
    required: true
  }) field!: any

  // __DATA
  private currentValue: any = this.value
  private open: boolean = false
  private finder: string = ''

  // __MOUNTED
  public mounted () {
    document.addEventListener('click', this.clickOutSide, false)
  }
  
  // __METHODS
  private select (val: any): void {
    if (this.multiple) {
      const hasVal: boolean = this.currentValue.some((s: any) => {
        return (this.object ? s.id : s) === val[this.field.key]
      })

      if (hasVal) {
        this.currentValue = this.currentValue.filter((s: any) => {
          return (this.object ? s.id : s) !== val[this.field.key]
        })
      } else {
        this.currentValue.push(
          this.object
            ? { id: val[this.field.key] }
            : val[this.field.key]
        )
      }
    } else {
      this.currentValue = val[this.field.key]
      this.open = false
    }

    this.$emit('input', this.currentValue)
  }

  private clear (): void {
    if (this.multiple) return void 0
    this.open = false
    this.currentValue = null
    this.$emit('input', this.currentValue)
  }

  /**
   * Check focus list.
   */
  private focus (val: any): boolean {
    return (this.multiple)
      ? this.currentValue.some((x: any) => (this.object ? x.id : x) === val[this.field.key])
      : this.currentValue === val[this.field.key]
  }

  /**
   * Close dropdown
   */
  private clickOutSide (e: any): void {
    if (!this.$el.contains(e.target)) {
      this.open = false
    }
  }

  private h (val: string): string {
    return hls(val, this.finder)
  }

  // __COMPUTED
  private get store (): any {
    const lo: any = (val: string): string => String(val).toLocaleLowerCase()
    const finder: string = lo(this.finder)
    let results: any = this.options

    if (this.search && finder) {
      results = this.options.filter((x: any) => lo(x[this.field.label]).includes(finder))
    }

    return results
  }

  private get label (): any {
    const cv: any = this.currentValue
    let result: any

    if (this.multiple) {
      result = cv.length
        ? `${this.placeholder} (${cv.length})`
        : this.placeholder
    } else {
      const x: any = this.options.find((h: any) => h[this.field.key] === cv)
      result = (x) ? x[this.field.label] : this.placeholder
    }

    return this.$tc(result, (this.multiple ? 2 : 1))
  }

  // __DESTROYED
  public destroyed () {
    document.removeEventListener('click', this.clickOutSide, false)
  }
}
